export function short_address(address:string){
    return address.substring(0,6)+"..."+address.substring(60,65)
}